import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'
// import watch from './watch'

export default {
  computed,
  data,
  methods,
  mounted,
  props,
//  watch,

  resourcePath: '/v1/professional/schedules/locks'
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/preview/resources/index.js